<div class="blue full body">
    <app-navbar></app-navbar>



<div class="main">
    <div class="white">
        <h1>THANK YOU FOR REGISTERATION</h1>
    </div>
</div>

<div>
    <app-footer></app-footer>
</div>
</div>